var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgentSetupActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8387 2C6.18163 2.01146 6.40375 2.12991 6.5869 2.34769C6.94931 2.77562 7.41694 3.00105 7.98588 3.00487C8.54703 3.00869 9.01465 2.79473 9.38875 2.38208C9.74727 1.98472 10.0473 1.91212 10.5539 2.10698C11.2437 2.37062 11.8711 2.73741 12.44 3.19973C12.7596 3.45954 12.857 3.80342 12.7206 4.1855C12.3309 5.29353 12.97 6.37099 14.1468 6.58878C14.5794 6.66901 14.8132 6.9059 14.895 7.33383C15.0431 8.11327 15.0314 8.88889 14.8795 9.66452C14.8093 10.0313 14.517 10.2949 14.1351 10.3561C12.9193 10.5433 12.2452 11.6666 12.6777 12.8014C12.8258 13.1873 12.7323 13.5426 12.4127 13.8024C11.8633 14.2495 11.2554 14.6048 10.5929 14.8684C10.2071 15.0213 9.81351 14.9258 9.56022 14.601C8.80422 13.619 7.31562 13.6458 6.59859 14.6392C6.34919 14.9869 5.9595 15.0824 5.55033 14.9296C4.82941 14.6621 4.17474 14.2877 3.57851 13.8101C3.25118 13.5464 3.16934 13.1796 3.3447 12.767C3.77336 11.7621 3.23559 10.6465 2.17954 10.3446C2.05484 10.3102 1.92234 10.2911 1.79374 10.272C1.42744 10.2147 1.14686 9.93961 1.08841 9.57664C0.959813 8.80102 0.971504 8.02922 1.12348 7.25742C1.20532 6.84095 1.48589 6.58496 1.92624 6.52764C2.89656 6.40156 3.57462 5.62594 3.53175 4.67074C3.52396 4.4797 3.4694 4.28484 3.40705 4.10144C3.27066 3.69643 3.36808 3.34492 3.70711 3.08129C4.27216 2.64571 4.89566 2.30566 5.56982 2.06495C5.67503 2.02675 5.78414 2.01146 5.8387 2Z",
    stroke: "#2940E5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 1.5,
    fill: "#2940E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 8.5,
    r: 1.5,
    fill: "#2940E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentSetupActive);
export default __webpack_public_path__ + "static/media/agent-setup-active.4d116a103a856972510405c73a306f53.svg";
export { ForwardRef as ReactComponent };